var map = {
	"./Isuzu-logo.png": 2578,
	"./Stars.svg": 5345,
	"./bike-removebg-preview.png": 4359,
	"./close-icon.svg": 2424,
	"./dashboard/dashboard10.png": 782,
	"./dashboard/dashboard16.png": 7797,
	"./dashboard/dashboard18.png": 9506,
	"./dashboard/dashboard20.png": 2270,
	"./deliverybike.png": 9762,
	"./electricsymbol.jpg": 5188,
	"./email-icon.svg": 9351,
	"./farasi-logo.png": 4691,
	"./flatbed.jpg": 1203,
	"./fleetImage.jpeg": 6849,
	"./fonts/Oxanium-VariableFont_wght.ttf": 6883,
	"./fonts/Sarabun-MediumItalic.ttf": 6980,
	"./fonts/Sarabun-Regular.ttf": 3573,
	"./gps.png": 7457,
	"./gpsdevice.png": 8075,
	"./gpsgarissa.png": 2874,
	"./gpss.png": 3816,
	"./gpsthikaroad.png": 5458,
	"./howo-logo.png": 8537,
	"./icon.svg": 2021,
	"./img/gps.png": 2733,
	"./img/gps2.png": 1754,
	"./img/gpstelematics.png": 6333,
	"./img/map.gif": 4136,
	"./img/slide1.png": 4539,
	"./img/slide2.png": 9639,
	"./img/slide3.png": 6955,
	"./img/slide4.png": 6693,
	"./img/truck1.jpeg": 1954,
	"./img/truck2.jpeg": 6022,
	"./img/truck3.jpeg": 7384,
	"./img/truck4.jpeg": 4727,
	"./img/truck6.jpeg": 9705,
	"./kenya-flag-icon.png": 4781,
	"./location-icon.svg": 9728,
	"./logo-instagram.svg": 9848,
	"./logo-linkedin.svg": 2418,
	"./logo-twitter.svg": 7513,
	"./logo.png": 6949,
	"./map.jpg": 5234,
	"./mercedes_benz_logo.jpeg": 2131,
	"./navi-logo.png": 2999,
	"./navibike.png": 7673,
	"./phone-icon.svg": 5679,
	"./profileavatar.png": 9612,
	"./redTruck.jpg": 1933,
	"./roadbike.png": 3400,
	"./runda-logo.png": 7992,
	"./scania-logo.jpeg": 4600,
	"./showroombike.png": 8514,
	"./tailwind.css": 1356,
	"./trade-in.jpg": 3200,
	"./tradeInTruck.jpeg": 4636,
	"./truck2.jpeg": 3918,
	"./truckLine.jpg": 9366,
	"./trucksImage.jpeg": 6250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;